import React from "react";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import "./nujobsViewEventDetails.scss";

export default function NuJobsViewEventDetails({
    jobId,
    selectedEventJD,
    selectedEvent,
    encodeJsonCB,
    isApplied,
    appliedOn,
    isDrawer = false,
    companyLogo,
    appliedJobs,
    setAppliedJobs,
    openJd,
    isLoggedin,
    applyNowCallBackLoggedIn,
}) {
    const navigate = useNavigate();

    const event = selectedEvent || {};

    // ==========================================
    // Sign In
    // ==========================================

    const handleSignin = () => {
        navigate("/nujobsotpprocess", {
            state: {
                reason: "start",
                trigger: "signin",
            },
        });
    };

    // ==========================================
    // Display Helpers
    // ==========================================

    const hasValue = (value) => {
        return (
            value !== undefined &&
            value !== null &&
            value !== ""
        );
    };

    const displayValue = (value) => {
        if (!hasValue(value)) return "-";

        if (typeof value === "boolean") {
            return value ? "Yes" : "No";
        }

        return value;
    };

    // ==========================================
    // Event Field - Read Only
    // ==========================================

    const EventField = ({ label, value }) => {
        if (!hasValue(value)) return null;

        return (
            <div className="nujobs-event-field">
                <div className="nujobs-event-field-label">
                    {label}
                </div>

                <div className="nujobs-event-field-value">
                    {displayValue(value)}
                </div>
            </div>
        );
    };

    // ==========================================
    // Event Link - Read Only
    // ==========================================

    const EventLink = ({ label, value }) => {
        if (!hasValue(value)) return null;

        const url =
            typeof value === "string" &&
            /^https?:\/\//i.test(value)
                ? value
                : null;

        return (
            <div className="nujobs-event-field">
                <div className="nujobs-event-field-label">
                    {label}
                </div>

                <div className="nujobs-event-field-value">
                    {url ? (
                        <a
                            href={url}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Open Link
                        </a>
                    ) : (
                        displayValue(value)
                    )}
                </div>
            </div>
        );
    };

    // ==========================================
    // Event Section
    // ==========================================

    const EventSection = ({ title, children }) => {
        return (
            <div className="nujobs-event-section">
                <h4>{title}</h4>
                {children}
            </div>
        );
    };

    // ==========================================
    // Application Status
    // ==========================================

    const applicationStatus =
        typeof isApplied === "function"
            ? isApplied()
            : "Not Applied";

    // ==========================================
    // Render
    // ==========================================

    return (
        <div className="nuJobsViewEventDetails-form-wrapper">

            {/* =====================================
                COMPANY LOGO
            ===================================== */}

            {companyLogo && (
                <div className="nuJobsViewJob-logo-container">
                    <img
                        className="nuJobsViewJob-logo-img"
                        src={companyLogo}
                        alt="Company Logo"
                    />
                </div>
            )}

            {/* =====================================
                EVENT TITLE
            ===================================== */}

            <div className="jd-view-value-title">
                {event.eventname ||
                    selectedEventJD?.JDDetails?.Title ||
                    "Hiring Event"}
            </div>

            {/* =====================================
                EVENT DETAILS
            ===================================== */}

            <EventSection title="Event Details">

                <div className="dual-input-wrapper">

                    <EventField
                        label="Event Name"
                        value={event.eventname}
                    />

                    <EventField
                        label="Event Type"
                        value={event.eventtype}
                    />

                </div>

                <EventField
                    label="Event Description"
                    value={event.eventdesc}
                />

            </EventSection>

            {/* =====================================
                REGISTRATION
            ===================================== */}

            <EventSection title="Registration">

                <div className="triple-input-wrapper">

                    <EventField
                        label="Registration Required"
                        value={event.regrequired}
                    />

                    <EventLink
                        label="Registration Link"
                        value={event.reglink}
                    />

                    <EventField
                        label="Scan and Register"
                        value={event.regscan}
                    />

                </div>

            </EventSection>

            {/* =====================================
                EVENT SCHEDULE
            ===================================== */}

            <EventSection title="Schedule">

                <div className="dual-input-wrapper">

                    <EventField
                        label="Start Date"
                        value={event.startdate}
                    />

                    <EventField
                        label="Start Time"
                        value={event.starttime}
                    />

                </div>

                <div className="dual-input-wrapper">

                    <EventField
                        label="End Date"
                        value={event.enddate}
                    />

                    <EventField
                        label="End Time"
                        value={event.endtime}
                    />

                </div>

                <div className="dual-input-wrapper">

                    <EventField
                        label="Registration Deadline"
                        value={event.deadlinedate}
                    />

                    <EventField
                        label="Deadline Time"
                        value={event.deadlinetime}
                    />

                </div>

            </EventSection>

            {/* =====================================
                EVENT LOCATIONS
            ===================================== */}

            <EventSection title="Event Locations">

                {/* Location 1 */}

                <div className="triple-input-wrapper">

                    <EventField
                        label="Venue / Address"
                        value={event.venue}
                    />

                    <EventField
                        label="City"
                        value={event.city}
                    />

                    <EventLink
                        label="Google Map Link"
                        value={event.googlemaplink}
                    />

                </div>

                {/* Location 2 */}

                {(hasValue(event.venue2) ||
                    hasValue(event.city2) ||
                    hasValue(event.googlemaplink2)) && (

                    <div className="triple-input-wrapper">

                        <EventField
                            label="Venue / Address - 2"
                            value={event.venue2}
                        />

                        <EventField
                            label="City - 2"
                            value={event.city2}
                        />

                        <EventLink
                            label="Google Map Link - 2"
                            value={event.googlemaplink2}
                        />

                    </div>
                )}

                {/* Location 3 */}

                {(hasValue(event.venue3) ||
                    hasValue(event.city3) ||
                    hasValue(event.googlemaplink3)) && (

                    <div className="triple-input-wrapper">

                        <EventField
                            label="Venue / Address - 3"
                            value={event.venue3}
                        />

                        <EventField
                            label="City - 3"
                            value={event.city3}
                        />

                        <EventLink
                            label="Google Map Link - 3"
                            value={event.googlemaplink3}
                        />

                    </div>
                )}

            </EventSection>

            {/* =====================================
                ADDITIONAL INFORMATION
            ===================================== */}

            <EventSection title="Additional Information">

                <div className="dual-input-wrapper">

                    <EventField
                        label="Created On"
                        value={event.postingdate}
                    />

                    <EventField
                        label="Created By"
                        value={event.postedby}
                    />

                </div>

                <div className="dual-input-wrapper">

                    <EventField
                        label="Last Updated"
                        value={event.updatedon}
                    />

                    <EventField
                        label="Updated By"
                        value={event.updatedby}
                    />

                </div>

            </EventSection>

            {/* =====================================
                APPLY NOW SECTION
                Existing application logic retained
            ===================================== */}

            <div className="nujobs-event-apply-section">

                {
                    applicationStatus === "Applied" ? (
                        <>
                            <Button
                                style={{
                                    width: "100%",
                                    height: "40px",
                                    fontWeight: "600",
                                }}
                                type="primary"
                                disabled={true}
                            >
                                Already Register on {appliedOn}
                            </Button>
                        </>
                    ) : isLoggedin ? (
                        <>
                            {
                                isDrawer ? (
                                    <></>
                                ) : (
                                    <>
                                        <Button
                                            style={{
                                                width: "100%",
                                                height: "40px",
                                                fontWeight: "600",
                                            }}
                                            type="primary"
                                            disabled={false}
                                            onClick={() =>
                                                applyNowCallBackLoggedIn(
                                                    encodeJsonCB
                                                )
                                            }
                                        >
                                            Apply Now
                                        </Button>
                                    </>
                                )
                            }
                        </>
                    ) : (
                        <>
                            <Button
                                style={{
                                    width: "100%",
                                    height: "40px",
                                    fontWeight: "600",
                                }}
                                type="primary"
                                onClick={handleSignin}
                                disabled={false}
                            >
                                Login to Register
                            </Button>
                        </>
                    )
                }

            </div>

        </div>
    );
}